import { API, graphqlOperation } from 'aws-amplify'
import vm from '../main'
const debug = process.env.NODE_ENV !== 'production'
const onSuccess = (resp) => {
  if (debug) {
    // console.log(resp)
  }
  return resp
}
const onError = (e) => {
  // console.log(e)
  // セッションが切れた場合は、ログイン画面へ移動
  if (e.toString() === 'Error: No current user') {
    vm.$router.push('/login')
  }
  throw e
}

const GraphqlAPI = (query) => {
  if (debug) {
    // console.log(query)
  }
  return API.graphql(graphqlOperation(query))
    .then(onSuccess)
    .catch(onError)
}

export default GraphqlAPI
